var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgATxtLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "735.096px",
    height: "71.871px",
    viewBox: "224.904 244.632 735.096 71.871",
    enableBackground: "new 224.904 244.632 735.096 71.871",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M294.291,316.503l-20.85-52.125l-21.145,52.125l-27.393-71.871h13.491l14.717,41.7l15.785-41.7h9.812 l15.49,41.7l15.085-41.7h12.412L294.291,316.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M351.077,244.632h12.105l26.982,69.485h-11.989l-6.353-16.478h-29.386l-6.353,16.478H324.07 L351.077,244.632z M346.704,286.718h20.85l-10.425-27.099L346.704,286.718z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M416.196,255.848h-19.157v-11.216h50.23v11.216h-19.157v58.258h-11.916V255.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M493.825,304.195c2.752,0.049,5.49-0.39,8.089-1.294c2.092-0.729,4.08-1.729,5.911-2.975 c1.812-1.162,3.421-2.612,4.766-4.292l7.972,7.843c-1.93,2.321-4.205,4.331-6.745,5.961c-2.616,1.699-5.435,3.065-8.39,4.065 c-3.725,1.253-7.637,1.858-11.565,1.791c-4.802,0.044-9.563-0.887-13.994-2.735c-4.192-1.739-7.992-4.305-11.173-7.543 c-3.181-3.271-5.693-7.13-7.396-11.362c-3.573-9.195-3.573-19.395,0-28.59c1.702-4.234,4.215-8.096,7.396-11.369 c3.185-3.234,6.983-5.798,11.173-7.543c4.433-1.846,9.193-2.774,13.994-2.729c3.753-0.072,7.488,0.516,11.038,1.735 c2.793,0.979,5.485,2.226,8.04,3.722c2.436,1.536,4.671,3.369,6.653,5.458l-8.095,7.861c-1.374-1.428-2.906-2.693-4.568-3.771 c-1.771-1.045-3.632-1.926-5.563-2.631c-2.419-0.863-4.975-1.278-7.543-1.227c-6.387-0.1-12.498,2.598-16.729,7.383 c-2.041,2.32-3.638,4.995-4.71,7.892c-2.257,6.153-2.257,12.906,0,19.06c1.075,2.896,2.672,5.571,4.71,7.893 C481.329,301.584,487.438,304.284,493.825,304.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M579.795,244.632h11.909v69.485h-11.909V284.24h-29.681v29.877h-11.915v-69.485h11.915v28.393h29.681 V244.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M730.884,244.632h12.111l26.982,69.485h-12.014l-6.354-16.478h-29.386l-6.354,16.478h-12.013 L730.884,244.632z M726.517,286.718h20.851l-10.425-27.099L726.517,286.718z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M828.173,287.484v-42.853h11.909v44.275c0.039,3.61-0.6,7.196-1.883,10.572 c-2.418,6.371-7.439,11.409-13.804,13.847c-7.175,2.649-15.061,2.649-22.236,0c-6.361-2.439-11.381-7.477-13.797-13.847 c-1.288-3.374-1.929-6.961-1.889-10.572v-44.275h11.915v42.853c0,4.967,1.24,8.977,3.722,12.025 c2.481,3.05,6.204,4.575,11.167,4.575c4.968,0,8.689-1.525,11.167-4.575C826.922,296.461,828.165,292.451,828.173,287.484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M863.312,244.632h11.915v58.257h29.576v11.217h-41.491V244.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M928.928,255.848h-19.157v-11.216H960v11.216h-19.157v58.258h-11.915V255.848z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentcolor",
    points: "684.204,258.742 671.719,289.201 653.26,244.632 640.254,244.632 671.326,316.503 696.297,258.742  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgATxtLogo);
export default __webpack_public_path__ + "static/media/a-txt-logo.13307cd6fc97f3d0023b349303df9d6c.svg";
export { ForwardRef as ReactComponent };